import { useRef, useState } from "react";
import axios from "axios";
import { ChevronLeft, ChevronRight, ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { API, apiError, authHeaders, mediaUrl } from "@/lib/api";

const move = (arr, i, d) => {
  const next = [...arr];
  [next[i], next[i + d]] = [next[i + d], next[i]];
  return next;
};

export const PhotoManager = ({ value, onChange }) => {
  const input = useRef(null);
  const [uploading, setUploading] = useState(0);

  const upload = async (files) => {
    const list = Array.from(files || []);
    if (!list.length) return;
    setUploading(list.length);
    const added = [];
    for (const file of list) {
      try {
        const form = new FormData();
        form.append("file", file);
        const { data } = await axios.post(`${API}/admin/upload/image`, form, { headers: authHeaders() });
        added.push(data.url);
      } catch (err) {
        toast.error(`${file.name}: ${apiError(err)}`);
      }
      setUploading((n) => n - 1);
    }
    if (added.length) {
      onChange([...value, ...added]);
      toast.success(`${added.length} foto aggiunte — ricordati di salvare`);
    }
    if (input.current) input.current.value = "";
  };

  return (
    <div className="flex flex-col gap-3" data-testid="admin-photo-manager">
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3">
        {value.map((src, i) => (
          <div key={src} className="relative group aspect-[3/4] rounded-xl overflow-hidden bg-white/5" data-testid={`admin-photo-${i}`}>
            <img src={mediaUrl(src)} alt="" className="w-full h-full object-cover" />
            <span className="absolute top-1.5 left-1.5 text-[10px] bg-black/70 rounded-full px-2 py-0.5">{i + 1}</span>
            <button type="button" aria-label="Rimuovi foto" data-testid={`admin-photo-remove-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))}
              className="absolute top-1.5 right-1.5 bg-black/70 rounded-full p-1 hover:bg-red-500/80"><X className="w-3 h-3" /></button>
            <div className="absolute bottom-1.5 inset-x-1.5 flex justify-between">
              <button type="button" aria-label="Sposta prima" disabled={i === 0} onClick={() => onChange(move(value, i, -1))}
                className="bg-black/70 rounded-full p-1 disabled:opacity-0 hover:bg-white/20"><ChevronLeft className="w-3 h-3" /></button>
              <button type="button" aria-label="Sposta dopo" disabled={i === value.length - 1} onClick={() => onChange(move(value, i, 1))}
                className="bg-black/70 rounded-full p-1 disabled:opacity-0 hover:bg-white/20"><ChevronRight className="w-3 h-3" /></button>
            </div>
          </div>
        ))}
        <button type="button" disabled={uploading > 0} onClick={() => input.current?.click()} data-testid="admin-photo-add-button"
          className="aspect-[3/4] rounded-xl border border-dashed border-white/25 flex flex-col items-center justify-center gap-2 text-white/60 hover:text-white hover:border-white/50 text-xs disabled:opacity-60">
          {uploading > 0 ? <><Loader2 className="w-5 h-5 animate-spin" /> {uploading} in corso</> : <><ImagePlus className="w-5 h-5" /> Aggiungi</>}
        </button>
      </div>
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" multiple className="hidden" data-testid="admin-photo-input" onChange={(e) => upload(e.target.files)} />
    </div>
  );
};
